var i = Object.defineProperty;
var a = (s, e, t) => e in s ? i(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var n = (s, e, t) => a(s, typeof e != "symbol" ? e + "" : e, t);
function r(s) {
  if (s)
    try {
      return JSON.parse(s);
    } catch {
    }
}
class l extends HTMLElement {
  constructor() {
    super(...arguments);
    n(this, "jsons", {});
  }
  async connectedCallback() {
    this.jsons = {}, this.querySelectorAll("script[type='application/json']").forEach((t, o) => {
      this.jsons[t.id || o.toString()] = r(t.textContent);
    });
  }
  getJson(t) {
    return typeof t == "number" ? Object.values(this.jsons)[t] : this.jsons[t];
  }
  /** protected method so our tree shake doesn't split tryParse into a separate tiny file */
  parseJson(t) {
    return r(t);
  }
}
export {
  l as B
};
